import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import VisibilitySensor from 'react-visibility-sensor';
import { Map } from 'immutable';

import formatPrice from 'lib/checkout/FormatPrice';

import { Location } from 'models/locations';
import Quote from 'models/quote';
import Venue from 'models/venue';
import Event from 'models/event';

import CurrencySymbol from 'components/common/currency-symbol';
import VenueSubheader from 'components/checkout/venue-subheader';
import EventTooltip from 'components/checkout/event-tooltip';

const propTypes = {
  selectedLocation: PropTypes.instanceOf(Location),
  venue: PropTypes.instanceOf(Venue),
  event: PropTypes.instanceOf(Event),
  sellers: PropTypes.instanceOf(Map),
  handleMoreAboutVisibilityChange: PropTypes.func.isRequired,
  showSelectedLocation: PropTypes.func.isRequired,
  totalPrice: PropTypes.number.isRequired,
};

const defaultProps = {
  selectedLocation: null,
  venue: null,
  event: null,
  sellers: Map(),
};

const CheckoutMobileHeader = ({
  selectedLocation,
  venue,
  event,
  sellers,
  handleMoreAboutVisibilityChange,
  showSelectedLocation,
  totalPrice,
}) => {
  const formattedPrice = formatPrice(totalPrice);
  const longPrice = (totalPrice && totalPrice.toString().length > 5);

  return (
    <div>
      <div className="row mobile-location-info border-color-light-grey border-side-bottom border-style-solid">
        <div className="col-xs-8">
          <h2 className="h6 sub with-sub wrap-ellipses">
            { selectedLocation.address1 }
          </h2>
          <h3 className="h6 sub wrap-ellipses">
            { selectedLocation.name }
          </h3>
          <p>
            <VisibilitySensor onChange={handleMoreAboutVisibilityChange} partialVisibility>
              <a className="text-size-12 weak" onClick={showSelectedLocation}>
                  +&nbsp;
                <FormattedMessage
                  id="checkout.more-about-location"
                  defaultMessage="MORE ABOUT THIS FACILITY"
                />
              </a>
            </VisibilitySensor>
          </p>
          <VenueSubheader venue={venue} />
        </div>
        <div className="col-xs-4">
          <p className={longPrice ? 'long-price price align-right' : 'price align-right'} >
            <sup>
              <CurrencySymbol location={selectedLocation} />
            </sup>
            { formattedPrice ? formattedPrice[0] : null }
            { formattedPrice && formattedPrice.length === 2 && formattedPrice[1] !== '0' ? <sup>{formattedPrice[1]}</sup> : null }
          </p>
        </div>
      </div>
      <EventTooltip
        sellers={sellers}
        selectedLocation={selectedLocation}
        event={event}
      />
    </div>
  );
};

CheckoutMobileHeader.propTypes = propTypes;
CheckoutMobileHeader.defaultProps = defaultProps;
export default CheckoutMobileHeader;
